import { render, staticRenderFns } from "./AdsList.vue?vue&type=template&id=19a88a78&scoped=true"
import script from "./AdsList.vue?vue&type=script&lang=js"
export * from "./AdsList.vue?vue&type=script&lang=js"
import style0 from "./AdsList.vue?vue&type=style&index=0&id=19a88a78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a88a78",
  null
  
)

export default component.exports